
<div class="container mt" id="service-container">
  <div class="row mb">
    <div class="col-md-12">
      <div class="breadcrumb-con">
        <div class="service-breadcrumb">
          <span class="breadcrumb-steps" *ngFor="let obj of breadcrumbSteps;"
                [class.activetab]="selectedIndex === (obj.id)">
                        <span *ngIf="checkNav(obj.id); else elseBlock" class="step"
                              (click)="switchTab(obj.id)">{{obj.name | translate}}</span>
                        <ng-template #elseBlock><span class="step inactivetab">{{obj.name | translate}}</span></ng-template>
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <mat-tab-group animationDuration="1000ms" [selectedIndex]="selectedIndex">
        <mat-tab>
          <ng-template mat-tab-label>
            <span class="tab-title">{{ 'testDrive.chooseVehicle' | translate}}</span>
            <span class="tab-hint">{{ 'testDrive.selectVehicle' | translate}}</span>
          </ng-template>
          <div class="service-content select-vehicle">
            <app-select-vehicle #form1 [stepIndex]="selectedIndex" (toShowFooter)="toShowFooterDetails($event)"
            (formEdited)="valuesChanges($event)" [src]="src"></app-select-vehicle>
            <app-your-information *ngIf="selectedIndex === 0" [isEditMode]="isEditMode" [selectedIndex]="selectedIndex" [isValidTransport]="isValidTransport()" [isFirstLoad]="isFirstLoad" (firstLoadConsumed)="markYourInformationFirstLoadConsumed()" (formEdited)="valuesChanges($event)"></app-your-information>
          </div>

        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label>
            <span class="tab-title">{{ 'service.service' | translate}}</span>
            <span class="tab-hint">{{ 'service.selectService' | translate}}</span>
          </ng-template>
          <div class="service-content select-service">
            <app-select-service #form2 [stepIndex]="selectedIndex"></app-select-service>
          </div>

        </mat-tab>
        <mat-tab [disabled]="!form2?.step?.valid">
          <app-your-information [isEditMode]="isEditMode" [selectedIndex]="selectedIndex" [isValidTransport]="isValidTransport()" [isFirstLoad]="isFirstLoad" (firstLoadConsumed)="markYourInformationFirstLoadConsumed()" (formEdited)="valuesChanges($event)" (transportEdited)="transportChanges($event)"></app-your-information>
          <ng-template mat-tab-label>
            <span class="tab-title">{{ 'service.appointmentTime' | translate}}</span>
            <span class="tab-hint">{{ 'service.selectTime' | translate}}</span>
          </ng-template>
          <div class="service-content">
            <app-appointment-time [transport]="transport" [vin]="vin" [appointmentId]="appointmentId"></app-appointment-time>
          </div>
        </mat-tab>
        <mat-tab [disabled]="true">
          <div class="service-content">
            <app-summary></app-summary>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</div>

<div id="service-sticky-footer">
  <div *ngIf="selectedIndex==3" id="accept-terms">
    <span class="label">
      {{getDisclaimerText}}
    </span>
</div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="sticky-breadcrumb">
          <div>
            <button (click)="gotoBack()"
                    [ngClass]="selectedIndex !== 0 && !isSubmitting ? 'btn-enable':''"
                    class="goback-btn"
                    [disabled]="selectedIndex === 0 || isSubmitting">{{ 'testDrive.back' | translate}}
            </button>
          </div>

          <div class="selection-info desktop spacer">
            <div class="footer-summaries">
            <ng-container *ngFor="let fs of serviceAppointmentFooterSummaries$ | async">
              <ng-container *ngIf="toShowFooterAppointment">
              <div class="footer-summary" *ngIf="fs.value">
                <div class="key">
                  {{fs.key | translate}}
                  <span class="disclaimer" *ngIf="fs.disclaimer">*</span></div>
                <div class="value">{{fs.value | translate}}</div>
              </div>
            </ng-container>
            </ng-container>
          </div>
          <div class="disclaimer-text" *ngIf="(serviceAppointmentFooterSummaries$ | async)?.length > 1 && 
            (serviceAppointmentFooterSummaries$ | async)[1]?.value">
            <span style="color:red">*</span>
            <span style="color: gray">{{'otherTexts.theActualPriceAndHoursMayVaryBasedOnTheVehicleTypeAndSize' | translate}}</span>
          </div>

        </div>

          <div class="spacer-mobile"></div>
          <div class="continue-btn">
            <button (click)="switchTab()"
                    class="continue" [class.submitting]="isSubmitting"
                    [ngClass]="isValidForm() && (selectedIndex !== 2 || isValidTransport()) ? 'btn-enable':'btn-disabled-color'"
                    [disabled]="isSubmitting">
              <ng-container *ngIf="isSubmitting; else serviceAppointmentLabel">
                <app-loading loadingSymbol="dots" [text]="'testDrive.submitting' | translate" color="var(--dashboard-primary-color)"
                             size=".7" [compact]="true"></app-loading>
              </ng-container>
              <ng-template #serviceAppointmentLabel>
                <span>{{continueBtnText[selectedIndex] | translate}}</span>
              </ng-template>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


